/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Popular_TagsInputs */

const en_directory_launch_popular_tags = /** @type {(inputs: Directory_Launch_Popular_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular tags`)
};

const zh_directory_launch_popular_tags = /** @type {(inputs: Directory_Launch_Popular_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门标签`)
};

/**
* | output |
* | --- |
* | "Popular tags" |
*
* @param {Directory_Launch_Popular_TagsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_popular_tags = /** @type {((inputs?: Directory_Launch_Popular_TagsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Popular_TagsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_popular_tags(inputs)
	return zh_directory_launch_popular_tags(inputs)
});
export { directory_launch_popular_tags as "directory.launch.popular_tags" }